import { withStyles } from "@material-ui/core";
import StyledToolTip from "../../../common/StyledToolTip";
import { getPickupClosingSoonText } from '../utils/utils';
import { isClosingSoonAlert, isClosingSoonWarning } from "../../../mapComponents/Popups/DispatchMap/utils";
import { TimerOffOutlined, TimerOutlined } from "@material-ui/icons";

const styles = (theme) => ({
  badge: {
    fontSize: 12,
    borderRadius: '100px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 38,
    height: 20,
    marginLeft: 4,
    marginRight : 4,
    padding: '2px 4px',
    fontWeight : 600,
    width : "fit-content"
  },
  defaultAlertBadge: {
    //This component is being used inside map marker popups and thus theme object is not supported there , so to keep styles consistent in all places we can use default values here itself.
    color: '#FFFFFF',
    backgroundColor: '#CF0000'
  },
  defaultWarningBadge: {
    color: '#666666',
    backgroundColor: '#EBEBEB',
    border: `1px solid #666666`
  },
  timerIcon: {
    marginRight: 2,
    fontSize : 16
  }
});

const getBadgeTimeValue = (timeToCloseInMins) => {
  const minutes = Math.abs(timeToCloseInMins);
  const hours = Math.floor(minutes / 60);
  const remainderMinutes = minutes % 60;

  if (hours > 0) {
    const minutesPart = remainderMinutes > 0 ? ` ${remainderMinutes}m` : "";
    return `${hours}h${minutesPart}`;
  }
  return `${remainderMinutes}m`;
}

const getBadgeClasses = ({ timeToCloseInMins, classes, closingSoonLimitConfig  }) => {
  if (isClosingSoonWarning(timeToCloseInMins, closingSoonLimitConfig)) {
    return classes.defaultWarningBadge;
  }
  if (isClosingSoonAlert(timeToCloseInMins, closingSoonLimitConfig)) {
    return classes.defaultAlertBadge;
  }
};
const ClosingSoonBadge = ({
  timeToCloseInMins,
  classes,
  showTooltip = true,
  closingSoonLimitConfig
}) => {
  if (timeToCloseInMins !== undefined && timeToCloseInMins !== null) { //We need this check explicitly to allow 0 values
    const showClosedIcon = timeToCloseInMins <=0;
    return (
      <StyledToolTip title={showTooltip ? getPickupClosingSoonText(timeToCloseInMins) : ''}>
        <span
          className={`${classes.badge} ${getBadgeClasses({
            timeToCloseInMins,
            classes,
            closingSoonLimitConfig
          })}`}>
          {showClosedIcon ? (
            <TimerOffOutlined className={classes.timerIcon} />
          ) : (
            <TimerOutlined className={classes.timerIcon} />
          )}
          {getBadgeTimeValue(timeToCloseInMins)}
        </span>
      </StyledToolTip>
    );
  }
  return null;
};

export default withStyles(styles)(ClosingSoonBadge);